import { businessInfo, navLinks } from '../data/business';
import { useState, useEffect } from 'react';
import { Menu, X, Phone, MapPin } from 'lucide-react';

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 border-b ${
        isScrolled 
          ? 'bg-white shadow-md py-3 border-gray-100' 
          : 'bg-white py-5 border-transparent'
      }`}
    >
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex justify-between items-center">
          {/* Logo */}
          <a href="#" className="flex items-center gap-3 group">
            <div className="flex flex-col">
              <span className="font-heading font-extrabold text-2xl leading-none text-text tracking-tight">
                BUDIMLIJA
              </span>
              <span className="text-sm font-bold tracking-[0.2em] text-primary">
                ELEKTRO
              </span>
            </div>
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-10">
            {navLinks.map((link) => (
              <a 
                key={link.name}
                href={link.href}
                className="text-base font-bold uppercase tracking-wide text-text hover:text-primary transition-colors relative group py-2"
              >
                {link.name}
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-primary transition-all duration-300 group-hover:w-full"></span>
              </a>
            ))}
          </nav>

          {/* CTA Buttons */}
          <div className="hidden md:flex items-center gap-4">
            <a 
              href={businessInfo.mapsLink}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 px-5 py-2.5 rounded border-2 border-gray-200 text-text font-bold hover:border-primary hover:text-primary transition-all"
            >
              <MapPin size={18} />
              <span className="hidden xl:inline">Navigacija</span>
            </a>
            <a 
              href={`tel:${businessInfo.phoneClean}`}
              className="flex items-center gap-2 px-6 py-2.5 bg-primary text-white rounded font-bold shadow-lg shadow-primary/30 hover:bg-primary-dark hover:scale-105 transition-all"
            >
              <Phone size={18} />
              <span>{businessInfo.phone}</span>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button 
            className="lg:hidden text-text hover:text-primary transition-colors p-2"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? (
              <X size={32} />
            ) : (
              <Menu size={32} />
            )}
          </button>
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && (
        <div className="absolute top-full left-0 right-0 bg-white shadow-2xl border-t border-gray-100 p-6 flex flex-col gap-4 lg:hidden animate-in slide-in-from-top-5 h-screen">
          {navLinks.map((link) => (
            <a 
              key={link.name}
              href={link.href}
              className="text-xl font-bold text-text py-4 border-b border-gray-100 hover:text-primary hover:pl-2 transition-all"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              {link.name}
            </a>
          ))}
          <div className="flex flex-col gap-4 mt-6">
            <a 
              href={businessInfo.mapsLink}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center gap-3 px-6 py-4 rounded border-2 border-primary text-primary font-bold text-lg"
            >
              <MapPin size={24} />
              Navigacija do nas
            </a>
            <a 
              href={`tel:${businessInfo.phoneClean}`}
              className="flex items-center justify-center gap-3 px-6 py-4 bg-primary text-white rounded font-bold shadow-lg text-lg"
            >
              <Phone size={24} />
              Pozovite: {businessInfo.phone}
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
